const Config = window.__BROWSER_CONFIG__ || {};

module.exports = Config;
